import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PROPERTY_TYPES } from '../../../constants';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';
import isObjectNullOrEmpty from '../../../utils/isObjectNullOrEmpty';

import { BuildingAdditionalDetails } from './AdditionalDetails/BuildingAdditionalDetails';
import { SiteAdditionalDetails } from './AdditionalDetails/SiteAdditionalDetails';
import { BuildingDescriptionDetails } from './AdditionalDetails/BuildingDescriptionDetails';
import { SiteRecordsDetails } from './AdditionalDetails/SiteRecordsDetails';

export class PropertyDetailAdditionalComponent extends Component {

  constructor(props) {
    super(props);
    this.state = { showAdditionalDetails: false };
    this.updateDetailsTab = this.updateDetailsTab.bind(this);
  }

  updateDetailsTab(shouldShow) {
    this.props.updateDetailsTab(shouldShow);
  }

  render() {
    const { about, external, internal } = this.props.property.additionalDetails;
    const isBuilding = this.props.type === PROPERTY_TYPES.BUILDINGS;
    const detailSectionsToShow = isBuilding ?
      this.props.viewer.buildingSettings.detailSectionsToShow :
      this.props.viewer.siteSettings.detailSectionsToShow;

    if (isBuilding) {
      const hasExternalAdditionalDetails = isObjectNullOrEmpty(external, ['constructionType', 'buildingDimensions', 'numberOfParkingSpaces']);
      const hasInternalAdditionalDetails = isObjectNullOrEmpty(internal, ['officeSquareFeet', 'floorType', 'floorThickness',
        'firstInsuranceClassRating', 'covenantsLinkURL', 'ceilingHeight', 'ceilingEaves', 'columnSpacing',
        'sprinklerType', 'craneHeight', 'numberOfDockDoors', 'numberOfDriveInDocks', 'dockAndDoorNotes']);
      const showAdditionalDetails = ((!hasExternalAdditionalDetails ||
        !hasInternalAdditionalDetails) && (!detailSectionsToShow ||
        detailSectionsToShow.includes('Additional Details')));
      const showSiteDescription = ((!detailSectionsToShow || detailSectionsToShow.includes('Site Description')));
      this.state.showAdditionalDetails = showAdditionalDetails;

      return (
        <div>
          <ConditionalWrapper condition={showAdditionalDetails}>
            <BuildingAdditionalDetails details={this.props.property.additionalDetails} />
          </ConditionalWrapper>
          <ConditionalWrapper condition={showSiteDescription}>
            <BuildingDescriptionDetails details={this.props.property.additionalDetails} />
          </ConditionalWrapper>
        </div>
      );
    }

    const {
      certifiedSiteStatus,
      zoning,
      specialtyFeatures = [],
      adjacentAvailableAcres,
      floodPlain,
      lastRecordedRealEstatePropertyTaxYear,
      fireInsuranceClassRating,
    } = about;
    const hasAdditionalDetails = isObjectNullOrEmpty(about, ['certifiedSiteStatus', 'zoning', 'specialtyFeatures',
      'adjacentAvailableAcres', 'floodPlain', 'lastRecordedRealEstatePropertyTaxYear',
      'fireInsuranceClassRating']);

    const showAdditionalDetails = !hasAdditionalDetails && ((certifiedSiteStatus || zoning.length ||
      (specialtyFeatures && specialtyFeatures.length) || adjacentAvailableAcres || floodPlain ||
      lastRecordedRealEstatePropertyTaxYear !== '' ||
      fireInsuranceClassRating !== '') &&
      (!detailSectionsToShow || detailSectionsToShow.includes('Additional Details')));

    const showSiteDescription = ((lastRecordedRealEstatePropertyTaxYear || fireInsuranceClassRating)
      && (!detailSectionsToShow || detailSectionsToShow.includes('Site Description')));
    this.state.showAdditionalDetails = showAdditionalDetails;

    return (
      <div>
        <ConditionalWrapper condition={showAdditionalDetails}>
          <SiteAdditionalDetails details={this.props.property.additionalDetails} />
        </ConditionalWrapper>
        <ConditionalWrapper condition={showSiteDescription}>
          <SiteRecordsDetails details={this.props.property.additionalDetails} />
        </ConditionalWrapper>
      </div>
    );
  }
}

PropertyDetailAdditionalComponent.propTypes = {
  type: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  updateDetailsTab: PropTypes.func,
};

export default PropertyDetailAdditionalComponent;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailAdditional/PropertyDetailAdditional.js